const missingImageSvg = `
<svg xmlns="http://www.w3.org/2000/svg" width="320" height="180" viewBox="0 0 640 360" role="img" aria-label="Bild otillgänglig">
  <rect width="640" height="360" fill="#f5f5f5"/>
  <rect x="1" y="1" width="638" height="358" fill="none" stroke="#c7c7c7" stroke-width="2" stroke-dasharray="10 8"/>
  <path d="M278 124h84c11 0 20 9 20 20v72c0 11-9 20-20 20h-84c-11 0-20-9-20-20v-72c0-11 9-20 20-20zm0 16c-2 0-4 2-4 4v53l30-30 25 25 13-13 24 24v-59c0-2-2-4-4-4h-84zm54 34a14 14 0 1 0 0-28 14 14 0 0 0 0 28z" fill="#707070"/>
  <text x="320" y="270" text-anchor="middle" font-family="Arial, sans-serif" font-size="24" fill="#424242">Bild otillgänglig</text>
</svg>`;

export const missingImagePlaceholder = `data:image/svg+xml;charset=utf-8,${encodeURIComponent(
  missingImageSvg
)}`;

export async function resolveImageDataOrPlaceholder(
  imageData: string | undefined | null
): Promise<string> {
  if (!imageData?.trim()) {
    return missingImagePlaceholder;
  }

  if (typeof globalThis.Image === "undefined") {
    return imageData;
  }

  return new Promise((resolve) => {
    const image = new globalThis.Image();
    image.onload = () => resolve(imageData);
    image.onerror = () => resolve(missingImagePlaceholder);
    image.src = imageData;
  });
}
